import * as Yup from 'yup';
import { UserRole } from '../../api/users';
import { isValidPhoneNumber } from '../../utils/phoneMask';

export interface AddUserFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  agency: string[];
  role: UserRole;
  accessTo: string[];
  office: string[];
}

export const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must not exceed 50 characters'),
  lastName: Yup.string()
    .required('Last name is required')
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must not exceed 50 characters'),
  email: Yup.string().required('Email is required').email('Invalid email format'),
  phone: Yup.string().when('accessTo', {
    is: (accessTo: string[]) => accessTo?.includes('leaderboard'),
    then: (schema) =>
      schema
        .required('Phone number is required')
        .test('phone-format', 'Phone number must be in format (XXX) XXX-XXXX', (value) => {
          if (!value) return false;
          return isValidPhoneNumber(value);
        }),
    otherwise: (schema) => schema.optional(),
  }),
  agency: Yup.array().of(Yup.string()).min(1, 'Agency is required').required('Agency is required'),
  role: Yup.string().required('User role is required'),
  accessTo: Yup.array().of(Yup.string()),
  office: Yup.array()
    .of(Yup.string())
    .when(['accessTo', 'role'], {
      is: (accessTo: string[], role: string) =>
        accessTo?.includes('leaderboard') && role === 'USER',
      then: (schema) =>
        schema.min(1, 'At least one office is required when Leaderboard access is selected'),
      otherwise: (schema) => schema,
    }),
});

export const defaultValues: AddUserFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  agency: [],
  role: UserRole.DIRECTOR,
  accessTo: [],
  office: [],
};
